module.exports = "<p>\n  ui-ux works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/ui-ux/ui-ux.component.html
// module id = ../../../../../src/app/ui-ux/ui-ux.component.html
// module chunks = main